<template>
  <div class="b_c_272727 p_tb_72">
    <div class="w_1200 m_lr_auto f_s_12">
      <div class=" ">
        <div class="t_a_r">
          <div class="c_fff m_t_20">Contact Us</div>
          <div class="c_9fa3a6 m_t_10">ShenZhen IGS Electronics co., Ltd</div>
          <div class="c_9fa3a6 m_t_10">Sales Manager: Derek wang</div>
          <div class="c_9fa3a6 m_t_10">Phone No.:0086-185-6675-6366</div>
          <div class="c_9fa3a6 m_t_10">Mail: Sales01@igstech.com.cn</div>
          <div class="c_9fa3a6 m_t_10 p_l_30">Sam@igstech.com.cn</div>
          <div class="c_9fa3a6 m_t_10">Add: 5F, Building 3, No. 129, Li Songlang First Industrial Zone, Guangming District, Shenzhen, Guangdong, China</div>
        </div>
        <!-- <div class="w_20p">
          <div class="c_fff m_t_20">增值服务</div>
          <div class="c_9fa3a6 m_t_10">DJI Care 随心换</div>
          <div class="c_9fa3a6 m_t_10">DJI Care 随心续享</div>
          <div class="c_9fa3a6 m_t_10">DJI Care Pro</div>
          <div class="c_9fa3a6 m_t_10">Osmo Shield</div>
          <div class="c_9fa3a6 m_t_10">DJI Care 行业无忧</div>
          <div class="c_9fa3a6 m_t_10">行业无人机保养服务</div>
          <div class="c_9fa3a6 m_t_10">农机关怀计划</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">购买渠道</div>
          <div class="c_9fa3a6 m_t_10">官方商城</div>
          <div class="c_9fa3a6 m_t_10">官方旗舰店</div>
          <div class="c_9fa3a6 m_t_10">官方直营店</div>
          <div class="c_9fa3a6 m_t_10">线下门店</div>
          <div class="c_9fa3a6 m_t_10">行业应用购买渠道</div>
          <div class="c_9fa3a6 m_t_10">农业植保机代理商</div>
          <div class="c_9fa3a6 m_t_10">专业影像代理商</div>
          <div class="c_9fa3a6 m_t_10">大疆商城 App</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">企业合作</div>
          <div class="c_9fa3a6 m_t_10">成为授权经销商</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">安全飞行</div>
          <div class="c_9fa3a6 m_t_10">安全飞行指引</div>
          <div class="c_9fa3a6 m_t_10">大疆飞行指南</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">帮助与支持</div>
          <div class="c_9fa3a6 m_t_10">产品支持</div>
          <div class="c_9fa3a6 m_t_10">服务申请与信息支持</div>
          <div class="c_9fa3a6 m_t_10">帮助中心</div>
          <div class="c_9fa3a6 m_t_10">售后服务政策</div>
          <div class="c_9fa3a6 m_t_10">下载中心</div>
          <div class="c_9fa3a6 m_t_10">安全与隐私</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">优惠折扣</div>
          <div class="c_9fa3a6 m_t_10">以旧换新</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">探索精彩大疆</div>
          <div class="c_9fa3a6 m_t_10">新闻中心</div>
          <div class="c_9fa3a6 m_t_10">精彩活动</div>
          <div class="c_9fa3a6 m_t_10">STEAM教育</div>
          <div class="c_9fa3a6 m_t_10">航拍无人机</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">社区</div>
          <div class="c_9fa3a6 m_t_10">天空之城</div>
          <div class="c_9fa3a6 m_t_10">大疆社区</div>
          <div class="c_9fa3a6 m_t_10">开发者</div>
        </div>
        <div class="w_20p">
          <div class="c_fff m_t_20">订阅我们</div>
          <div class="c_9fa3a6 m_t_10">第一时间获得大疆的最新动态</div>
          <div class="c_9fa3a6 m_t_10">请输入您的邮箱地址</div>
        </div> -->
      </div>
      <div class="m_t_60">
        <div class="flex">
          <img class="w_50 m_r_20" src="http://igstech.com.cn/resources/logo/logo.png" />
          <!-- <div class="c_9fa3a6 m_r_10">关于我们</div>
          <div class="c_9fa3a6 m_r_10">联系我们</div>
          <div class="c_9fa3a6 m_r_10">招聘精英</div>
          <div class="c_9fa3a6 m_r_10">市场合作</div>
          <div class="c_9fa3a6 m_r_10">代理商门户</div>
          <div class="c_9fa3a6 m_r_10">供应商门户</div>
          <div class="c_9fa3a6 m_r_10">RoboMaster</div>
          <div class="c_9fa3a6 m_r_10">慧飞培训中心</div>
          <div class="c_9fa3a6 m_r_10">大疆互娱</div>
          <div class="c_9fa3a6 m_r_10">大疆车载</div> -->
        <div class="c_6c7073">粤ICP备20052141号-1</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterCategory"
};
</script>

<style>
</style>